import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { classNames } from "primereact/utils";
import { useForm, Controller } from "react-hook-form";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { useZonesQuery, useAddDomainesMutation, useExistDomaineMutation } from "../cdsApiSlice";
import { Toast } from "primereact/toast";

interface Props {
  setter: () => void;
  errorDialog: boolean;
  domaines: any
}

export const HandleDomaine = ({ setter, errorDialog, domaines }: Props) => {

  const footerDialog = () => {
    return (
      <>
        <Button
          label={"ANNULER"}
          disabled={false}
          onClick={() => setter()}
          className="mr-3 p-button-outlined p-button-sm"
        />

        <Button
          id="hook-form"
          onClick={() => {
          }}
          type="submit"
          label={"CRÉER"}
          className="p-button p-button-sm"
        />
      </>
    );
  };

  return (
    <>
      {/* <Toast ref={toast} /> */}

      <Dialog
        header={"Créer une nouvelle métadonnée"}
        footer={footerDialog}
        visible={errorDialog}
        style={{ width: "25vw" }}
        modal
        onHide={() => {
          setter();
        }}
      >
        
      </Dialog>
    </>
  );
};
